export default __webpack_public_path__ + "dcc9e6d2573e0a8e2ce479f88c97d0a6.svg";